/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nda_Field_EmailInputs */



/**
* | output |
* | --- |
* | "E-mail" |
*
* @param {Nda_Field_EmailInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const nda_field_email = /** @type {((inputs?: Nda_Field_EmailInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nda_Field_EmailInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("E-mail")
	if (locale === "es") return /** @type {LocalizedString} */ ("Correo electrónico")
	if (locale === "pt") return /** @type {LocalizedString} */ ("E-mail")
	if (locale === "it") return /** @type {LocalizedString} */ ("E-mail")
	return /** @type {LocalizedString} */ ("E-mail")
});